import React from "react";
import LegalPage from "./LegalPage";
import { LEGAL } from "./legalData";

const PoliticaCookies = () => (
  <LegalPage title="Política de Cookies" lastUpdated={LEGAL.lastUpdated}>
    <h2>1. ¿Qué son las cookies?</h2>
    <p>
      Una cookie es un pequeño archivo que se almacena en tu dispositivo al visitar una web y que
      permite, entre otras cosas, mantener tu sesión iniciada y garantizar la seguridad del Servicio.
    </p>

    <h2>2. Cookies que utilizamos</h2>
    <p>
      Actualmente {LEGAL.nombreComercial} utiliza <strong>únicamente cookies técnicas necesarias</strong>
      para el funcionamiento del Sitio Web y del Servicio. <strong>No utilizamos cookies de analítica,
      publicidad ni seguimiento de terceros.</strong>
    </p>
    <table className="legal-table">
      <thead>
        <tr><th>Cookie</th><th>Tipo</th><th>Finalidad</th><th>Duración</th></tr>
      </thead>
      <tbody>
        <tr>
          <td>Sesión / autenticación</td>
          <td>Técnica (necesaria)</td>
          <td>Mantener la sesión iniciada y proteger el acceso a la cuenta</td>
          <td>Sesión</td>
        </tr>
        <tr>
          <td>clubsagent_cookie_consent</td>
          <td>Técnica (necesaria)</td>
          <td>Recordar tu elección sobre el aviso de cookies</td>
          <td>Persistente</td>
        </tr>
      </tbody>
    </table>

    <h2>3. Consentimiento</h2>
    <p>
      Las cookies técnicas necesarias están exentas del deber de consentimiento conforme a la normativa
      y a la Guía de la AEPD, ya que resultan imprescindibles para prestar el Servicio. Aun así, te
      informamos de su uso mediante el aviso de cookies. Si en el futuro incorporamos cookies de
      analítica o publicidad, solicitaremos tu consentimiento previo mediante un panel de configuración.
    </p>

    <h2>4. Cómo gestionar o desactivar las cookies</h2>
    <p>
      Puedes configurar tu navegador para bloquear o eliminar las cookies. Ten en cuenta que desactivar
      las cookies técnicas puede impedir el correcto funcionamiento del Servicio (por ejemplo, el inicio
      de sesión). Consulta la ayuda de tu navegador:
    </p>
    <ul>
      <li>Google Chrome — Configuración → Privacidad y seguridad → Cookies</li>
      <li>Mozilla Firefox — Ajustes → Privacidad y seguridad</li>
      <li>Safari — Preferencias → Privacidad</li>
      <li>Microsoft Edge — Configuración → Cookies y permisos del sitio</li>
    </ul>

    <h2>5. Contacto</h2>
    <p>
      Si tienes dudas sobre esta Política de Cookies, escríbenos a {LEGAL.email}.
    </p>
  </LegalPage>
);

export default PoliticaCookies;
